import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const CreateShop = () => {
  const [form, setForm] = useState({
    shopname: "",
    ownername: "",
    shopfulladdress: "",
    shoppin: "",
    contactnumber: "",
    smname: "",
    smemail: "",
    smmobile: "", // Added
  });
  const [loading, setLoading] = useState(false);

  // Helper to increment shopCode (supports both MBS001 and MBS0001)
  const getNextShopCode = (codes) => {
    let maxNum = 0;
    codes.forEach((code) => {
      const match = code.match(/^MBS0*(\d+)$/);
      if (match) {
        const num = parseInt(match[1], 10);
        if (num > maxNum) maxNum = num;
      }
    });
    // Use 4 digits if any code has 4 digits, else 3 digits
    const padLength = codes.some((code) => /^MBS\d{4}$/.test(code)) ? 4 : 3;
    return `MBS${(maxNum + 1).toString().padStart(padLength, "0")}`;
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // 1. Get all shops
      const allRes = await axios.get(
        "https://api.dremerz.net/api/DZ_8921_Mybankshoppy_Create_Shops_ShopLists"
      );
      const shops = Array.isArray(allRes.data) ? allRes.data : [];
      const codes = shops.map((shop) => shop.shopCode).filter(Boolean);

      const newShopCode = getNextShopCode(codes);

      // 2. Prepare form data
      const formData = new FormData();
      formData.append("shopCode", newShopCode);
      formData.append("shopname", form.shopname);
      formData.append("ownername", form.ownername);
      formData.append("shopfulladdress", form.shopfulladdress);
      formData.append("shoppin", form.shoppin);
      formData.append("contactnumber", form.contactnumber);
      formData.append("smname", form.smname);
      formData.append("smemail", form.smemail);
      formData.append("smmobile", form.smmobile); // Added

      const now = new Date();
      const createdDate = now.toISOString().slice(0, 10);
      const createdTime = now.toTimeString().slice(0, 8);
      formData.append("createdDate", createdDate);
      formData.append("createdTime", createdTime);

      // 3. Save new shop
      await axios.post(
        "https://api.dremerz.net/api/DZ_8921_Mybankshoppy_Create_Shops_ShopLists",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      alert(`Agent created successfully! Agent Code: ${newShopCode}`);
      setForm({
        shopname: "",
        ownername: "",
        shopfulladdress: "",
        shoppin: "",
        contactnumber: "",
        smname: "",
        smemail: "",
        smmobile: "", // Added
      });
    } catch (error) {
      alert("Error creating agent. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="container mt-4"
      style={{ maxWidth: 1350 }}
    >
      {/* Stepper-style sub-navbar */}
      <div
        className="d-flex justify-content-between align-items-center mb-4"
        style={{ gap: 0 }}
      >
        <Link
          to="/createshop"
          className="btn btn-outline-primary btn-sm flex-fill mx-1"
          style={{ borderRadius: "20px" }}
        >
          1. Create Agent
        </Link>
        <Link
          to="/shoplist"
          className="btn btn-outline-primary btn-sm flex-fill mx-1"
          style={{ borderRadius: "20px" }}
        >
          2. Agent List
        </Link>
        <Link
          to="/DownloadShopQr"
          className="btn btn-outline-primary btn-sm flex-fill mx-1"
          style={{ borderRadius: "20px" }}
        >
          3. Download QR
        </Link>

        <Link
          to="/shopleadslist"
          className="btn btn-outline-primary btn-sm flex-fill mx-1"
          style={{ borderRadius: "20px" }}
        >
          4. Leads List
        </Link>
      </div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="mb-0">Create New Agent</h3>
      </div>
      <div className="mb-3">
        <label className="form-label">Agent Name:</label>
        <input
          type="text"
          name="shopname"
          value={form.shopname}
          onChange={handleChange}
          required
          className="form-control"
          placeholder="Enter agent name"
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Owner Name:</label>
        <input
          type="text"
          name="ownername"
          value={form.ownername}
          onChange={handleChange}
          required
          className="form-control"
          placeholder="Enter owner name"
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Agent Full Address:</label>
        <input
          type="text"
          name="shopfulladdress"
          value={form.shopfulladdress}
          onChange={handleChange}
          required
          className="form-control"
          placeholder="Enter full address"
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Agent PINCODE:</label>
        <input
          type="text"
          name="shoppin"
          value={form.shoppin}
          onChange={handleChange}
          required
          className="form-control"
          placeholder="Enter shop PIN"
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Contact Number:</label>
        <input
          type="text"
          name="contactnumber"
          value={form.contactnumber}
          onChange={handleChange}
          required
          className="form-control"
          placeholder="Enter contact number"
        />
      </div>
      {/* New SM Name field */}
      <div className="mb-3">
        <label className="form-label">SM Name:</label>
        <input
          type="text"
          name="smname"
          value={form.smname}
          onChange={handleChange}
          required
          className="form-control"
          placeholder="Enter SM Name"
        />
      </div>
      {/* New SM Email field */}
      <div className="mb-3">
        <label className="form-label">SM Email:</label>
        <input
          type="email"
          name="smemail"
          value={form.smemail}
          onChange={handleChange}
          required
          className="form-control"
          placeholder="Enter SM Email"
        />
      </div>
      {/* New SM Mobile field */}
      <div className="mb-3">
        <label className="form-label">SM Mobile:</label>
        <input
          type="text"
          name="smmobile"
          value={form.smmobile}
          onChange={handleChange}
          required
          className="form-control"
          placeholder="Enter SM Mobile"
        />
      </div>
      <button
        type="submit"
        className="btn btn-primary w-100 mb-5"
        disabled={loading}
      >
        {loading ? "Creating..." : "Create Agent"}
      </button>
    </form>
  );
};

export default CreateShop;
